<template>
  <el-cascader
    :key="Math.random()"
    ref="elementCascade"
    v-model="currentValue"
    :placeholder="fillPlaceHolder"
    :name="name"
    :options="cascaderOptions"
    :collapse-tags="collapseTags"
    :readonly="readonly"
    :disabled="disabled"
    :required="required"
    :filterable="filterable"
    :props="{ multiple: true }"
    clearable
    @input="handleModelInput"
    @focus="handleFocus"
  >
  </el-cascader>
</template>

<script>
export default {
  props: {
    collapseTags: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    labelField: {
      default: 'value',
      type: String
    },
    name: String,
    placeholder: {
      default: '',
      type: String
    },
    multiple: {
      default: false,
      type: Boolean
    },
    value: [String, Number, Array],
    options: Array,
    optionsFunction: Function,
    readonly: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    },
    valueField: {
      default: 'id',
      type: String
    },
    filterable: {
      default: true,
      type: Boolean
    },
    loading: {
      default: false,
      type: Boolean
    },
    selectFirstOnDefault: {
      default: false,
      type: Boolean
    },
    translateLabels: Boolean,
    optionDisabled: Function,
    tooltip: [Boolean, String]
  },
  data() {
    return {
      currentValue: this.value,
      cascaderOptions: []
    };
  },
  computed: {
    fillPlaceHolder() {
      return this.currentValue ? '' : this.placeholder;
    },
    readOnlyValue() {
      const currentOption = this.selectOptions.find(option => option[this.valueField] === this.currentValue);
      return currentOption && currentOption[this.labelField];
    },
    clearable() {
      return !this.required && !this.multiple;
    },
    showClose() {
      return this.clearable && !this.valueIsEmpty() && !this.disabled;
    }
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    }
  },
  async created() {
    this.cascaderOptions = await this.getOptions();
  },
  methods: {
    async getOptions() {
      return this.options || (await this.optionsFunction());
    },
    handleClear() {
      this.$emit('input', null);
    },
    valueIsEmpty() {
      return (
        this.value === '' ||
        this.value === null ||
        this.value === undefined ||
        (Array.isArray(this.value) && !this.value.length)
      );
    },
    focus() {
      this.handleFocus();
    },
    setSoftFocus() {
      const cascader = this.$refs.elementCascade;
      this.$nextTick(() => {
        cascader.setSoftFocus();
      });
    },
    hasNoPreviousFocusTarget(event) {
      return event && !event.relatedTarget;
    },
    isMultipleSelectClickFocus(event) {
      return this.multiple && event && this.$el.contains(event.relatedTarget);
    },
    handleFocus(event) {
      const select = this.$refs.elementCascade;
      if (!select) {
        return;
      }
      if (this.valueIsEmpty() || this.hasNoPreviousFocusTarget(event) || this.isMultipleSelectClickFocus(event)) {
        select.focusFirstNode();
      } else {
        this.setSoftFocus();
      }
    },
    handleModelInput(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>

<style language="scss">
.el-cascader {
  width: 400px;
}
</style>

<style scoped>
.material-label {
  color: #9e9e9e;
}
</style>
